module.exports = __webpack_public_path__ + "static/img/RW1266_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RW1266_1.png
// module id = UdVA
// module chunks = 0